import type { ReactNode } from "react";
import type { DictionaryEntry, VisibleFields } from "../types";

type EntryCardProps = {
  entry: DictionaryEntry;
  query: string;
  compact?: boolean;
  visibleFields: VisibleFields;
};

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const highlightText = (text: string | null | undefined, query: string): ReactNode => {
  const safeText = text ?? "";
  if (!query.trim()) return safeText;
  const regex = new RegExp(`(${escapeRegExp(query)})`, "ig");
  return safeText.split(regex).map((part, index) =>
    index % 2 === 1 ? (
      <mark key={`${part}-${index}`} className="highlight">
        {part}
      </mark>
    ) : (
      part
    )
  );
};

export function EntryCard({ entry, query, compact, visibleFields }: EntryCardProps) {
  return (
    <article className={`entry-card ${compact ? "compact" : ""}`}>
      <header className="card-header">
        <div>
          <div className="term">{highlightText(entry.term, query)}</div>
          {visibleFields.english && (
            <div className="subtitle">
              {entry.eng ? highlightText(entry.eng, query) : "Needs English translation"}
            </div>
          )}
        </div>
        <div className="rank-chip">#{entry.rank.toLocaleString()}</div>
      </header>

      {visibleFields.definition && (
        <p className="definition">{highlightText(entry.def ?? "", query)}</p>
      )}

      <footer className="meta-row">
        {visibleFields.pos && <span className="pill">{entry.pos}</span>}
      </footer>
    </article>
  );
}
